/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Page_TitleInputs */

const en_claims_page_title = /** @type {(inputs: Claims_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claims`)
};

const fr_claims_page_title = /** @type {(inputs: Claims_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamations`)
};

/**
* | output |
* | --- |
* | "Claims" |
*
* @param {Claims_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_page_title = /** @type {((inputs?: Claims_Page_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Page_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_page_title(inputs)
	return fr_claims_page_title(inputs)
});